import { importProvidersFrom } from '@angular/core';
import { NgxsModule } from '@ngxs/store';

import { AuthState } from './application/auth.state';
import { IAuthConfig } from './models/auth-config';
import { AUTH_CONFIG } from './tokens/auth-config.token';

/**
 * Adds authentication support to the application.
 *
 * @param config - The configuration for the auth domain
 */
export const provideAuth = (config: IAuthConfig) => {
    return [
        { provide: AUTH_CONFIG, useValue: config },
        importProvidersFrom([ NgxsModule.forFeature([ AuthState ]) ])
    ];
};
